import React, { useState } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import axios from 'axios';
import PrimaryNav from "../../components/PrimaryNav/PrimaryNav";

const DRS_VERSION = `1.1.0`
const API_SUBSCRIPTION_KEYS_URI = `selfservice/subscription-keys`;

const API_SUBSCRIPTION_KEYS_URL =
    (!process.env.REACT_APP_GATEWAY_URL || process.env.REACT_APP_GATEWAY_URL === 'localhost')
        ? `http://localhost:8080/${API_SUBSCRIPTION_KEYS_URI}`
        : `https://${process.env.REACT_APP_GATEWAY_URL}/drs/${DRS_VERSION}/${API_SUBSCRIPTION_KEYS_URI}`;

function Credentials() {
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [subscriptionKeys, setSubscriptionKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Get account and username before useEffect
    const account = isAuthenticated && accounts.length > 0 ? accounts[0] : null;
    const username = account ? account.idTokenClaims.given_name : null;

   // Fetch subscription keys when authenticated
    React.useEffect(() => {
        // Don't try to fetch until MSAL reports the user is authenticated and we have an account
        if (!isAuthenticated || !account) {
            // clear any previous data and avoid flashing an error
            setSubscriptionKeys([]);
            setError('');
            setLoading(false);
            return;
        }

        const fetchSubscriptionKeys = async () => {
            setLoading(true);
            setError('');
            try {
                let accessToken = account.idToken;
                // Call API to get subscription keys
                const apiResponse = await axios.get(API_SUBSCRIPTION_KEYS_URL, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });
                setSubscriptionKeys(apiResponse.data.subscriptions || []);
            } catch (err) {
                setError('Authentication or API call failed.');
            } finally {
                setLoading(false);
            }
        };
        fetchSubscriptionKeys();
    }, [isAuthenticated, account]);

    return (
        <>
            <PrimaryNav />
            <main>
                <div>
                    {/* <h2>Authenticate to View Subscription Keys</h2>
                    <button onClick={() => handleLogin()} disabled={loading}>
                        Login with CDC B2C
                    </button>
                    <button onClick={() => handleLogin()} disabled={loading}>
                        Login with SAMS B2C
                    </button> */}
                    {isAuthenticated && username && (
                        <div style={{ margin: '20px 0', padding: '10px', background: '#f0f6ff', borderRadius: '8px' }}>
                            <h3>Welcome, {username}!</h3>
                            <p>You are now logged in.</p>
                        </div>
                    )}
                    {loading && <p>Loading...</p>}
                    {error && <p style={{ color: 'red' }}>{error}</p>}

                    {subscriptionKeys && Object.entries(subscriptionKeys).length > 0 && (
                        <div style={{ margin: '2em 0 0 0' }}>
                            <h3 style={{ color: '#2a4d8f', margin: '0 0 1em 0' }}>Your Subscription Keys</h3>
                            {Object.entries(subscriptionKeys).map(([product, keys], idx) => {
                                const productName = product.split('/').pop();
                                return (
                                    <div key={idx} style={{ margin: '0 0 1.25em 0', padding: '0.75em 1em', background: '#f8fbff', border: '1px solid #dbeafe', borderRadius: '8px', boxShadow: '0 2px 6px rgba(42,77,143,0.05)' }}>
                                        <div style={{ fontSize: '1.08em', fontWeight: 'bold', color: '#1e293b', margin: '0 0 0.4em 0' }}>
                                            <span role="img" aria-label="key" style={{ marginRight: '0.5em' }}>🔑</span>
                                            {productName}
                                        </div>
                                        <div style={{ display: 'flex', gap: '1.5em', flexWrap: 'wrap' }}>
                                            <div>
                                                <span style={{ fontWeight: '500', color: '#475569' }}>Primary Key:</span>
                                                <span style={{ marginLeft: '0.5em', fontFamily: 'monospace', color: '#2563eb' }}>{keys.primary_key}</span>
                                            </div>
                                            <div>
                                                <span style={{ fontWeight: '500', color: '#475569' }}>Secondary Key:</span>
                                                <span style={{ marginLeft: '0.5em', fontFamily: 'monospace', color: '#64748b' }}>{keys.secondary_key}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </main>
        </>
    );
}

export default Credentials;